
import
  Vue from 'vue'
import {
  DAILY_MENU_TOP_GROUP_CHANGE_SET,
  DAILY_MENU_TOP_GROUP_SAVED, GET_MODE, GET_SELECTED_MENU_ITEM, GET_SHOW_CONTROL_BUTTONS_MODE, USER_LOGGED_IN,
} from '@/store/getter-types'
import GroupOptionSelector from '@/components/order/GroupOptionSelector.vue'
import {
  PLACE_NEW_RESERVATION,
  CHANGE_EXISTING_RESERVATION,
  CANCEL_EXISTING_RESERVATION,
  RESTORE_EXISTING_RESERVATION,
  FETCH_TIME_BLOCK_COLLECTION,
  SET_SELECTED_MENU_ITEM,
  FETCH_RESERVATION_BY_ID,
  ORDER_CONFIRMATION,
  SET_IS_ORDER_CONFIRMATION, FETCH_DASHBOARD
} from '@/store/action-types'
import MenuGroupItem from '@/model/MenuGroupItem'
import DailyMenuOption from '@/model/DailyMenuOption'
import GroupControlButtons from '@/components/order/GroupControlButtons.vue'
import MenuReservationItem from '@/model/MenuReservationItem'
import { TranslateResult } from 'vue-i18n'
import {
  ChangeExistingReservationPayload,
  ChangeExistingReservationWithIdPayload,
  CreateNewReservationPayload,
  ReservationsOffersPayload,
  UserCredentialsPayload
} from '@/types/payload'
import { getLocale } from '@/services/system'
import {
  isValidDateForOrdering,
  isSelectionDifferentThenReservation,
  validateOrderCorrectness
} from '@/services/food-ordering'
import moment from 'moment'
import { ReservationStatus } from '@/types/enums'
import { showErrorResponseDialog } from '@/services/error'
import { AxiosError } from 'axios'
import {Component, Prop, Watch} from "vue-property-decorator";
import {Action} from "vuex-class";
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import Configuration from "@/model/Configuration";
import ControlOrderDialog from "@/components/order/ControlOrderDialog.vue";
import _ from "lodash"
import {RatingModel} from "@/model/RatingModel";
import {usePiniaStore} from "@/store/piniaStore";

@Component({
  components: {
    GroupOptionSelector,
    GroupControlButtons,
    ControlOrderDialog}
})

export default class TopGroup extends Vue {

  @Prop({type: Object as () => MenuGroupItem, required: true}) menuGroupItem!: MenuGroupItem
  @Prop({type: Array as () => MenuGroupItem[], required: true}) menuGroupList!: MenuGroupItem[]
  @Prop({type: Array as () => Configuration[], required: true}) configuration!: Configuration[]
  @Prop({type: Array as () => any[], required: true}) settingsData!: any[]
  @Prop({type: Date, required: true}) date!: Date
  @Prop({type: Array as () => MenuReservationItem[] | null}) reservationItem!: MenuReservationItem[] | null
  @Prop({type: Boolean}) setFreeDay!: boolean
  @Prop({type: Boolean, default: false}) readonly customerConfiguration!: boolean
  @Prop({type: String}) getEventName!: string
  @Action(FETCH_TIME_BLOCK_COLLECTION) fetchTimeBlockCollection!: ({ (): Promise<BusinessTimeBlockCollection[]> })
  @Action(FETCH_RESERVATION_BY_ID) fetchReservationBySelectedId!: ({ (payload: any): Promise<any[]> })
  @Action(ORDER_CONFIRMATION) orderConfirmation!: ({ (payload: UserCredentialsPayload): Promise<boolean> })
  @Action(SET_IS_ORDER_CONFIRMATION) setIsOrderConfirmation!: ({ (payload: boolean): Promise<void> })


  $refs!: {
    actionHeight: HTMLElement
    title: HTMLElement
  }

  private showCancellationConfirmationDialog: boolean = false
  private saveInProgress: boolean = false
  private cancellationInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarText: TranslateResult | string = ''
  private snackBarColor: string = ''
  private currentSelection: Map<MenuGroupItem, any> = new Map()
  private isDataChanged: boolean = false
  private tab: number | null = null
  private restartReservation: boolean = false
  private timeBlockCollection: BusinessTimeBlockCollection[] | null = null
  private timeBlockId: string | null = null
  private business: string | null = null
  private selectedTimeBlock: any | null = null
  private restartedReservation: boolean = false
  private isUpdate: boolean = false
  private showControlDialog: boolean = false
  private selectedMenu: string | undefined = undefined
  private showWaitList: boolean = false
  private loading: boolean = false
  private cardHeight: any | null = null
  private userId: string = ''
  private username: string | null = null
  private partialUserId: string = ''
  private isInvalidCredentials: boolean = false
  private timeOut: ReturnType<typeof setTimeout>  | null = null
  private restore: boolean = false
  private isAmountChanged: boolean = false
  private isMultipleGroupMenu: boolean = false
  private lastReservationDetailData: any[] = []
  private lastReservationNumber: number[] = []
  private ratingDeliveryTimeData: number | undefined = undefined
  private selectedOfferRating: any |null = null
  private piniaStore: any = usePiniaStore()
  private isRefreshData:boolean = false




  get showConfirmButtons (): boolean {
    return this.$store.getters[GET_SHOW_CONTROL_BUTTONS_MODE]
  }

  get getFirstReservationItem (): MenuReservationItem | undefined {
    return _.first(this.reservationItem)
  }

  get getMultipleReservationItem (): MenuReservationItem | undefined {
    let test: any | null = null
    this.reservationItem?.forEach((item: any) => {
      test = item
    })
    return test
  }


  get isTimeBlockChanged (): boolean {
    if(this.timeBlockCollection && this.timeBlockCollection[this.selectedTimeBlock] && this.timeBlockCollection[this.selectedTimeBlock].id) {
      if( this.timeBlockCollection![this.selectedTimeBlock].id === _.first(this.reservationItem)?.timeBlock.id) {
        return false
      }else if(this.timeBlockCollection![this.selectedTimeBlock].id !== _.first(this.reservationItem)?.timeBlock.id){
        return true
      } else{
        return false
      }
    }
    return false
  }

  get isTimeBlockChangeMultiple (): boolean {
    if(this.timeBlockCollection && this.timeBlockCollection[this.selectedTimeBlock] && this.timeBlockCollection[this.selectedTimeBlock].id && this.reservationItem && this.reservationItem.length > 0) {
      if(this.reservationItem.find((item: any) => item.timeBlock.id === this.timeBlockCollection![this.selectedTimeBlock].id)) {
        return false
      } else{
        return true
      }
    } else {
      return false
    }
  }

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get dateLabel (): string {
    return moment(this.date)
        .locale(getLocale())
        .format('dddd D.M.Y').toLocaleLowerCase()
  }

  /** Flag či je povolená manipulácia so stavom objednávky alebo nie
  *
  * @return boolean
  */
  get isManipulationAllowed(): boolean {
    let isTrue: boolean = false
    if (_.first(this.reservationItem) && _.first(this.reservationItem)!.status === 'delivered' && !this.lastReservationDetailData) {
      isTrue = false
    } /*else if (!isValidDateForOrdering(this.date as unknown as Date)) {
      return false
    }*/
    else if(this.isEnabledRating) {
      isTrue = true
    } else {
      isTrue = true
    }

    return isTrue
  }

  get isPriseForTag (): any[] {
    let data: any[] = []
    data = this.currentUser.boarderList[0].customer.configuration.allow_show_price_for_tag
    return data
  }

  get isEnabledRating(): boolean {
    this.ratingDeliveryTimeData = this.currentUser.boarderList[0].customer.configuration.last_order_rating_delivery_time_delta ? this.currentUser.boarderList[0].customer.configuration.last_order_rating_delivery_time_delta : undefined
    return this.currentUser.boarderList[0].customer.configuration.allow_rating_last_order

  }

  get selectedMenuItem(): any {
    return this.$store.getters[GET_SELECTED_MENU_ITEM]
  }

  get currentUser(): any {
    return this.$store.getters[USER_LOGGED_IN]
  }

  get isMultiplePortion (): boolean {
    return this.currentUser.boarderList[0].customer.configuration.allow_multiple_portions || false
  }

  get isBoarderNote (): boolean {
    return this.currentUser.boarderList[0].customer.configuration.allow_reservation_note || false
  }

  get statusMessageClass(): string | undefined {
    if (_.first(this.reservationItem)) {
      switch (_.first(this.reservationItem)!.status) {
        case ReservationStatus.active:
          return 'reservation-active'
        case ReservationStatus.canceled:
          return 'reservation-canceled'
        case ReservationStatus.delivered:
          return 'reservation-delivered'
        case ReservationStatus.notDelivered:
          return 'reservation-not-delivered'
      }
    }

    return undefined
  }

  get reservationStatusMessage(): TranslateResult | undefined {
    if(this.timeBlockCollection && this.timeBlockCollection.length == 1){
      const deadLine = moment(this.timeBlockCollection[0].reservationDeadline.toString(),'HH:mm:ss').format('HH:mm')
      return this.$t('orderPage.noticeOrderFoodBeforeDefinedTime',{deadLine: deadLine})
    }

    if (this.isManipulationAllowed) {
      this.$t('orderPage.orderSummaryLabel', { day: this.dateLabel })

      if (_.first(this.reservationItem)) {
        switch (_.first(this.reservationItem)!.status) {
          case ReservationStatus.active:
            return this.$t('orderPage.reservationForDateIsActiveMessage', { date: this.dateLabel })
          case ReservationStatus.canceled:
            return this.$t('orderPage.reservationForDateIsCanceledMessage', { date: this.dateLabel })
          case ReservationStatus.delivered:
            return this.$t('orderPage.reservationWasAlreadyDeliveredMessage')
        }
      } else {
        return this.$t('orderPage.noReservationSoFarMessage', { date: this.dateLabel })
      }
    } else {
      if (_.first(this.reservationItem)) {
        switch (_.first(this.reservationItem)!.status) {
          case ReservationStatus.canceled:
            return this.$t('orderPage.reservationWasCanceledMessage')
          case ReservationStatus.delivered:
            return this.$t('orderPage.reservationWasAlreadyDeliveredMessage')
          case ReservationStatus.notDelivered:
            return this.$t('orderPage.reservationWasNotDeliveredMessage')
          default:
            return this.$t('orderPage.reservationWasProcessedMessage')
        }
      }
    }
    return undefined
  }

  get isOfferEmpty(): boolean {
    // Ziadna z podkupin nemoze mat definovanu ponuku
    if(this.tab !== null) {
      return this.menuGroupList[this.tab].subGroupList.every((i: MenuGroupItem) => {
        return i.optionList.every((option: DailyMenuOption) => option.offer === undefined)
      })
    } else {
      return false
    }
  }

  get isSubmitButtonDisabled (): boolean {
    return this.selectedTimeBlock == null || this.isOfferEmpty || this.timeBlockCollection![this.selectedTimeBlock].id === _.first(this.reservationItem)?.timeBlock.id
  }

  get topMenuGroup(): boolean {
    return this.$store.getters[DAILY_MENU_TOP_GROUP_CHANGE_SET]
  }

  get topMenuGroupSaved(): any {
    return this.$store.getters[DAILY_MENU_TOP_GROUP_SAVED]
  }

  getTabNumber() {
    if(this.selectedMenu && this.selectedMenu === "Denné menu" ) {
      this.tab = 0
    }else if(this.selectedMenu && this.selectedMenu === "Bagety" ) {
      this.tab = 1
    }else if( this.selectedMenu && this.selectedMenu === "Minútky" ) {
      this.tab = 2
    }else if( this.selectedMenu && this.selectedMenu === "Šaláty" ) {
      this.tab = 3
    } else if( this.selectedMenu && this.selectedMenu === "XXL" ) {
      this.tab = 4
    }else {
      this.tab = 0
    }
    this.$store.dispatch(SET_SELECTED_MENU_ITEM, undefined)
  }

  get isAcceptanceProcess(): boolean {
    let condition: boolean = false
    const foundItem: any = this.settingsData.find((c: any) => c.key ===  'tenant.allow_acceptance_process')
    if(foundItem){
      condition = foundItem.value === 'true'
    } else {
      condition = false
    }

    return condition
  }

  get isAlertShow ():boolean {
    if(!this.isMultipleGroupMenu){
      return !!(this.isAmountChanged || this.isDataChanged || this.timeBlockCollection && this.timeBlockCollection[this.selectedTimeBlock] && _.first(this.reservationItem) && _.first(this.reservationItem)!.timeBlock && this.timeBlockCollection[this.selectedTimeBlock].id !== _.first(this.reservationItem)!.timeBlock.id)
    } else {
      return this.isAmountChanged  || this.isDataChanged || this.isTimeBlockChangeMultiple
    }
  }

  get getReservationData():any {
    let data:any[] = []
    this.lastReservationDetailData!.forEach((item:any) => {
      item.forEach((i:any) => {
        data.push(i)
      })

    })
    return data
  }


  isTimeBlockDisabled (item: any): boolean {
    if(moment(this.date).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') ) {
      if(moment().isAfter(moment(item.reservationDeadline, 'HH:mm:ss'))) {
        if(item.deadlineForPreviousDay && moment().isBefore(moment(item.reservationDeadline, 'HH:mm:ss').add(1, 'day'))) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    } else if(moment(this.date).isBefore(moment())) {
      return true
    } else if(_.first(this.reservationItem) && _.first(this.reservationItem)?.status !== ReservationStatus.active) {
      return true
    } else {
      return false
    }
  }

  @Watch('menuGroupItem')
  watchMenuGroupItem (newVal: MenuGroupItem): void {
    if (newVal) {
      this.currentSelection.clear()
      this.setCurrentSelectionByReservation()
      this.updateIsDataChangedFlag()
      this.setTimeBlock()
    }
  }

  @Watch('reservationItem')
  watchReservationItem (newVal: any): void {
    this.updateIsDataChangedFlag()
    this.setTimeBlock()
    this.selectedMenu = this.selectedMenuItem
    this.getTabNumber()
  }

  @Watch('selectedMenuItem')
  watchSelectedMenu (newVal: any): void {
    if(newVal){
      this.selectedMenu = newVal
      this.getTabNumber()
    }
  }

  @Watch('restore')
  watcRestore (newVal: any): void {
    if(newVal){
      this.restore = newVal
    }
  }

  @Watch('showCancellationConfirmationDialog')
  watcShowCancellationConfirmationDialog (newVal: boolean): void {
    if(newVal){
      this.showCancellationConfirmationDialog = newVal
      if(this.showCancellationConfirmationDialog === true) {
        window.addEventListener('keyup',this.performSave)
      }
    }
  }

  newAmount (option: DailyMenuOption): void {
    let changes: boolean[] = []
    this.currentSelection.forEach((value: DailyMenuOption | DailyMenuOption[], key: MenuGroupItem) => {
      if(value instanceof Array) {
        value.forEach((item: DailyMenuOption) => {
          if(item && item.offer && item.offer.id === option.offer!.id) {
            item.offer.amount = option.offer!.amount
          }

          if(item.offer) {

            this.reservationItem?.forEach((i: any) => {
              const foundItem = i.reservedOffers.find((a: any) => a.dailyMenuOffer.id === item.offer!.id)
              if (foundItem && foundItem.amount !== item.offer!.amount) {
                changes.push(true)
              } else {
                changes.push(false)
              }
            })

          } else {
            changes.push(false)
          }
        })
      } else {
        if(value && value.offer && value.offer.id === option.offer!.id) {
          value.offer.amount = option.offer!.amount
        }

        if(value.offer) {

          this.reservationItem?.forEach((i: any) => {
            const foundItem = i.reservedOffers.find((item: any) => item.dailyMenuOffer.id === value.offer!.id)
            if (foundItem && foundItem.amount !== value.offer!.amount) {
              changes.push(true)
            } else {
              changes.push(false)
            }
          })

        } else {
          changes.push(false)
        }

      }
    })

    this.isAmountChanged = changes.includes(true)
  }

  getReservationItem (menuGroupId: string):  MenuReservationItem | null {
    const foundReservationItem: MenuReservationItem | undefined = this.reservationItem?.find((item: MenuReservationItem) => item.topMenuGroup.id === menuGroupId)
    return foundReservationItem ? foundReservationItem : null
  }

  setTimeBlock (): void {
    if(this.reservationItem) {
      const foundItem: any = this.timeBlockCollection?.find((item: any) => item.id === _.first(this.reservationItem)?.timeBlock.id)
      if(foundItem) {
        const index: number = this.timeBlockCollection!.indexOf(foundItem)
        this.selectedTimeBlock = index
      }
    } else {
      this.selectedTimeBlock = null
      this.timeBlockCollection?.forEach((item: BusinessTimeBlockCollection) => {
        if(!this.isTimeBlockDisabled(item) && this.selectedTimeBlock === null) {
          const index: number = this.timeBlockCollection!.indexOf(item)
          this.selectedTimeBlock = index
        }
      })
    }
  }

  // <editor-fold desc="Event handlers">
  onSelectedOptionChange (groupItem: MenuGroupItem, selectedOption: DailyMenuOption | DailyMenuOption[] | undefined): void {
    if (selectedOption) {
      if(selectedOption instanceof Array) {
        let value: DailyMenuOption[] = []
        selectedOption.forEach((item: DailyMenuOption) => {
          value.push(item)

        })
        this.currentSelection.set(groupItem, value)
      } else {
        this.currentSelection.set(groupItem, selectedOption)
      }
    } else if (this.currentSelection.has(groupItem)) {
      this.currentSelection.delete(groupItem)
    }
    this.updateIsDataChangedFlag()
    this.$emit('selectionChange', this.currentSelection)
  }

  onCloseControlDialogClick():void {
    this.showControlDialog = false
  }


  onPlaceNewReservationClick (): void {

    if(this.currentSelection && this.currentSelection.size > 0 && this.tab !== null && !this.isMultipleGroupMenu) {
      let condition: boolean[] = []
      let topMenuGroup: MenuGroupItem = this.menuGroupList[this.tab]
      this.currentSelection.forEach((value: any, key: any) => {
        const foundItem: MenuGroupItem | undefined = topMenuGroup.subGroupList.find((item: MenuGroupItem) => item.id === key.id)
        condition.push(foundItem ? true : false)
      })

      if(condition.includes(false) && validateOrderCorrectness(this.currentSelection, this.menuGroupList[this.tab], this.configuration)) {
        this.isUpdate = false
        this.showControlDialog = true
        let selectionPayload = this.currentSelection
        this.currentSelection.forEach((value: any, key: any) => {
          const foundItem: MenuGroupItem | undefined = this.menuGroupList[this.tab!].subGroupList.find((item: MenuGroupItem) => item.id === key.id)
          if(!foundItem) {
            selectionPayload.delete((key))
          }
        })
        //this.onConfirmDialogClick(selectionPayload)
      } else {
        if(validateOrderCorrectness(this.currentSelection, this.menuGroupList[this.tab], this.configuration )){
          this.showControlDialog = true
        }else{
          this.snackBarColor = 'error'
          this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
          this.showSnackBar = true
        }
      }
    } else if(this.isMultipleGroupMenu) {
      this.isUpdate = true
      this.showControlDialog = true
    } else {
      this.snackBarColor = 'error'
      this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
      this.showSnackBar = true
    }
  }

  async refreshData ():Promise<void>{
    const payload = _.first(this.reservationItem)!.id
    this.loading = true
    try {
      const data: any = await this.fetchReservationBySelectedId(payload)
      this.$emit('refreshData',data)
    } catch (e) {
      this.snackBarColor = 'error'
      this.snackBarText = this.$t('orderPage.errorRefreshData')
      this.showSnackBar = true
    }finally {
      this.loading = false
    }
  }

  async placeNewReservationClick(selectionPayload: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]>,desciption: string | null): Promise<void> {
    this.timeBlockId = this.selectedTimeBlock ? `/api/time-block/${this.timeBlockCollection![this.selectedTimeBlock].id}` : `/api/time-block/${this.timeBlockCollection![0].id}`
    const business: any = `/api/business/${this.business}`
    if(!this.isTimeBlockDisabled(this.selectedTimeBlock ? this.selectedTimeBlock : this.timeBlockCollection![0].id)) {
      if (this.currentSelection && this.tab !== null ) {
        this.saveInProgress = true
        this.showWaitList = true

        if(this.isMultipleGroupMenu) {
          let payloadData: CreateNewReservationPayload[] = []
          selectionPayload.forEach((value: DailyMenuOption | DailyMenuOption[],key:MenuGroupItem) => {
            const foundTopGroup: MenuGroupItem | undefined = this.menuGroupList.find((item: MenuGroupItem) => item.subGroupList.find((i: MenuGroupItem) => i.id === key.id))
            let reservationsOffers: ReservationsOffersPayload[] = []
            if(value instanceof Array) {
              value.forEach((item: DailyMenuOption) => {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
              })
            } else {
              reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
            }
            const foundPayloadData: CreateNewReservationPayload | undefined = payloadData.find((a: CreateNewReservationPayload) => a.topMenuGroup == parseInt(foundTopGroup!.id))

            if(!foundPayloadData) {
              payloadData.push(
                  {
                    boarder: this.currentUser.boarderList[0].id,
                    topMenuGroup: parseFloat(foundTopGroup!.id),
                    reservedOffers: reservationsOffers,
                    timeBlock: this.timeBlockId!,
                    business: business,
                    date: moment(this.date).format('YYYY-MM-DD'),
                    boarderNote: desciption && desciption.trim().length > 0 ? desciption.trim() : null,
                  }
              )
            } else {
              foundPayloadData.reservedOffers = foundPayloadData.reservedOffers.concat(reservationsOffers)
            }
          })

          let promises: any[] = []

          payloadData.forEach((payload: CreateNewReservationPayload) => {
            promises.push(this.createReservation(payload))
          })

          await Promise.all(promises as Promise<Object[]>[])

        } else {
          let topMenuGroupId: number = parseFloat(this.menuGroupList[this.tab].id)
          if (topMenuGroupId && validateOrderCorrectness(selectionPayload, this.menuGroupList[this.tab], this.configuration)) {
            let reservationsOffers: ReservationsOffersPayload[] = []

            selectionPayload.forEach((value) => {
              if(value instanceof Array) {
                value.forEach((item: DailyMenuOption) => {
                  reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
                })

              } else {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
              }
            })
            const payload: CreateNewReservationPayload = {
              boarder: this.currentUser.boarderList[0].id,
              topMenuGroup: parseFloat(this.menuGroupList[this.tab].id),
              reservedOffers: reservationsOffers,
              timeBlock: this.timeBlockId,
              business: business,
              date: moment(this.date).format('YYYY-MM-DD'),
              boarderNote: desciption && desciption.trim().length > 0 ? desciption.trim() : null,
            }

            this.createReservation(payload)

          } else {
            this.snackBarColor = 'error'
            this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
            this.showSnackBar = true
            this.$emit('updateData')
          }
        }
      } else {
        this.snackBarColor = 'error'
        this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
        this.showSnackBar = true
        this.$emit('updateData')
      }
    }
  }

  async createReservation (payload: CreateNewReservationPayload): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(PLACE_NEW_RESERVATION, payload)

      this.$emit('newReservationCreated', reservationItem)
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
      this.$emit('updateData')
    } finally {
      this.saveInProgress = false
    }
  }

  onChangeReservationClick (): void {
    if(this.currentSelection && this.currentSelection.size > 0 && this.tab !== null && !this.isMultipleGroupMenu) {
      let condition: boolean[] = []
      let topMenuGroup: MenuGroupItem = this.menuGroupList[this.tab]
      this.currentSelection.forEach((value: DailyMenuOption | DailyMenuOption[], key: MenuGroupItem) => {
        const foundItem: MenuGroupItem | undefined = topMenuGroup.subGroupList.find((item: MenuGroupItem) => item.id === key.id)
        condition.push(foundItem ? true : false)
      })

      if(condition.includes(false) && validateOrderCorrectness(this.currentSelection, this.menuGroupList[this.tab], this.configuration )) {
        this.isUpdate = true
        this.showControlDialog = true
        let selectionPayload = this.currentSelection
        this.currentSelection.forEach((value: DailyMenuOption | DailyMenuOption[], key: MenuGroupItem) => {
          const foundItem: MenuGroupItem | undefined = this.menuGroupList[this.tab!].subGroupList.find((item: MenuGroupItem) => item.id === key.id)
          if(!foundItem) {
            selectionPayload.delete((key))
          }
        })
        //this.onConfirmDialogClick(selectionPayload)

      } else {
        if(validateOrderCorrectness(this.currentSelection, this.menuGroupList[this.tab], this.configuration )){
          this.isUpdate = true
          this.showControlDialog = true//this.changeReservationClick(this.currentSelection)
        }else{
          this.snackBarColor = 'error'
          this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
          this.showSnackBar = true
        }
      }
    } else if(this.isMultipleGroupMenu) {
      this.isUpdate = true
      this.showControlDialog = true
    }  else{
      this.snackBarColor = 'error'
      this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
      this.showSnackBar = true
    }
  }

  restoreOffer() {
    this.showControlDialog = false
    this.onRestoreReservationClick()
  }


  onConfirmDialogClick (selectionPayload: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]>, desciption: string | null) {
    if(_.first(this.reservationItem)?.topMenuGroup.id){
      if(this.isUpdate ) {
        this.showControlDialog = false
        this.changeReservationClick(selectionPayload,desciption)
      } else if (this.restore) {
        this.onRestoreReservationClick()
      } else{
        this.showControlDialog = false
        this.placeNewReservationClick(selectionPayload,desciption)
      }
    } else {
      this.showControlDialog = false
      this.placeNewReservationClick(selectionPayload,desciption)
    }
  }

  performSave(event: KeyboardEvent) {
    if(!this.isInvalidCredentials) {
      if (event.key !== "Enter") {
        this.partialUserId += event.key
      } else {
        if (this.partialUserId.includes('lunchmenu.today')) {
          this.userId = this.partialUserId.slice(-36)
        } else {
          this.userId = this.partialUserId
        }
        this.partialUserId = ''
        this.isInvalidCredentials = false
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.cancellationInProgress = true
        this.onLogUser(this.userId)
      }
    }
  }

  async onLogUser(item: string): Promise<void> {
    const payload: UserCredentialsPayload = {
      username: item,
      password: 'qr'
    }
    this.setIsOrderConfirmation(true)
    const response: boolean = await this.orderConfirmation(payload)
    this.cancellationInProgress = false
    this.setIsOrderConfirmation(false)
    if(response){
      this.onConfirmCancellationButtonClick()
    } else {
      window.addEventListener('keyup',this.performSave)
      this.isInvalidCredentials = true
    }
  }

  async changeReservationClick (selectionPayload: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]>,description: string | null): Promise<void> {
    this.timeBlockId = `/api/time-block/${this.timeBlockCollection![this.selectedTimeBlock].id}`
    const business: any = `/api/business/${this.business}`
    if(!this.isTimeBlockDisabled(this.selectedTimeBlock)) {
      if (this.tab !== null && validateOrderCorrectness(selectionPayload, this.menuGroupList[this.tab], this.configuration )) {
        this.saveInProgress = true
        this.showWaitList = true

        if(this.isMultipleGroupMenu) {
          let payloadData: ChangeExistingReservationPayload[] = []
          selectionPayload.forEach((value: DailyMenuOption | DailyMenuOption[], key: MenuGroupItem) => {
            const foundTopGroup: any = this.menuGroupList.find((item: MenuGroupItem) => item.subGroupList.find((i: MenuGroupItem) => i.id === key.id))
            let reservationsOffers: ReservationsOffersPayload[] = []
            if(value instanceof Array) {
              value.forEach((item: DailyMenuOption) => {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
              })
            } else {
              reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
            }
            const foundPayloadData: ChangeExistingReservationPayload | undefined = payloadData.find((a: ChangeExistingReservationPayload) => a.topMenuGroup === foundTopGroup.id)
            if(!foundPayloadData) {
              payloadData.push(
                  {
                    topMenuGroup: parseFloat(foundTopGroup.id),
                    reservedOffers: reservationsOffers,
                    timeBlock: this.timeBlockId!,
                    business: business,
                    boarderNote: description && description.trim().length > 0 ? description.trim() : null,
                  }
              )
            } else {
              foundPayloadData.reservedOffers = foundPayloadData.reservedOffers.concat(reservationsOffers)
            }
          })

          this.reservationItem!.forEach((item: MenuReservationItem) => {
            const foundReservationPayload: ChangeExistingReservationPayload | undefined = payloadData.find((i: ChangeExistingReservationPayload) => item.topMenuGroup.id === i.topMenuGroup)
            if(!foundReservationPayload) {
              payloadData.push(
                  {
                    topMenuGroup: item.topMenuGroup.id,
                    reservedOffers: [],
                    timeBlock: this.timeBlockId!,
                    business: business,
                    boarderNote: description && description.trim().length > 0 ? description.trim() : null,
                  }
              )
            }
          })

          let promises: any[] = []

          payloadData.forEach((b: ChangeExistingReservationPayload) => {
            const foundReservation: MenuReservationItem | undefined = this.reservationItem!.find((c: MenuReservationItem) => c.topMenuGroup.id === b.topMenuGroup)
            if(foundReservation) {
              const payload: ChangeExistingReservationWithIdPayload = {
                reservationId: foundReservation.id,
                payload: b
              }
              promises.push(this.changeReservation(payload))
            } else {
              const payload: CreateNewReservationPayload = {
                boarder: this.currentUser.boarderList[0].id,
                topMenuGroup: b.topMenuGroup,
                reservedOffers: b.reservedOffers,
                timeBlock: this.timeBlockId!,
                business: business,
                date: moment(this.date).format('YYYY-MM-DD'),
                boarderNote: description && description.trim().length > 0 ? description.trim() : null,
              }
              promises.push(this.createReservation(payload))
            }

          })

          await Promise.all(promises as Promise<Object[]>[])

        } else {
          let reservationsOffers: ReservationsOffersPayload[] = []
          selectionPayload.forEach((value) => {
            if(value instanceof Array) {
              value.forEach((item: DailyMenuOption) => {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
                //offerIds.push(parseInt(item.offer!.id))
              })

            } else {
              reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
              //offerIds.push(parseInt(value.offer!.id))
            }
          })

          const payloadData: ChangeExistingReservationPayload = {
            topMenuGroup: parseFloat(this.menuGroupList[this.tab].id),
            reservedOffers: reservationsOffers,
            timeBlock: this.timeBlockId,
            business: business,
            boarderNote: description && description.trim().length > 0 ? description.trim() : null,
          }

          const payload: ChangeExistingReservationWithIdPayload = {
            reservationId: _.first(this.reservationItem)!.reservationId,
            payload: payloadData
          }

         this.changeReservation(payload)

        }
      } else {
        this.snackBarColor = 'error'
        this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
        this.showSnackBar = true
        this.$emit('updateData')
      }
    } else {
      this.snackBarColor = 'error'
      this.snackBarText =  this.$t('orderPage.incompleteOrderMessage')
      this.showSnackBar = true
      this.$emit('updateData')
    }
  }

  async changeReservation (payload: ChangeExistingReservationWithIdPayload): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(CHANGE_EXISTING_RESERVATION, payload)
      this.$emit('reservationChanged', reservationItem, 'changed')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
      this.$emit('updateData')
    } finally {
      this.saveInProgress = false
    }
  }

  async restoreReservation (payload: any): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(CANCEL_EXISTING_RESERVATION, payload)
      window.removeEventListener('keyup',this.performSave)
      if(this.timeOut) {
        clearTimeout(this.timeOut)
      }

      this.$emit('reservationChanged', reservationItem, 'canceled')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
      this.cancellationInProgress = false
    }
  }

  async restoredReservation (payload: any): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(RESTORE_EXISTING_RESERVATION,payload)
      this.restartedReservation = true
      this.$emit('reservationChanged', reservationItem, 'restored')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
      this.saveInProgress = false
      this.restartedReservation = false
    }
  }


  onCancelReservationClick (): void {
    this.showCancellationConfirmationDialog = true
  }

  async fetchData (): Promise<void> {
    try {
      this.timeBlockCollection = await this.fetchTimeBlockCollection()
    }catch (e) {
    }
  }

  onReservationRstoreClick () {
    this.restore = true
    this.showControlDialog = true
  }

  async onRestoreReservationClick (): Promise<void> {
    if (this.reservationItem && this.isMultipleGroupMenu) {
      this.saveInProgress = true
      let promises: any[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        promises.push(this.restoredReservation(item))
      })
    } else if(this.reservationItem && !this.isMultipleGroupMenu) {
      try {
        const reservationItem: MenuReservationItem = await this.$store.dispatch(RESTORE_EXISTING_RESERVATION, _.first(this.reservationItem)!)
        this.restartedReservation = true
        this.$emit('reservationChanged', reservationItem, 'restored')
      } catch (e) {
        this.showSaveErrorMessage(e as AxiosError)
      } finally {
        this.saveInProgress = false
        this.restartedReservation = false
      }
    }
  }


  onCancelCancellationButtonClick (): void {
    this.showCancellationConfirmationDialog = false
    window.removeEventListener('keyup',this.performSave)
    if(this.timeOut) {
      clearTimeout(this.timeOut)
    }
  }

  async onConfirmCancellationButtonClick (): Promise<void> {
    this.showCancellationConfirmationDialog = false

    if (this.reservationItem &&  this.isMultipleGroupMenu) {
      this.cancellationInProgress = true
      let promises: any[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        promises.push(this.restoreReservation(item))
      })
    } else if(this.reservationItem && !this.isMultipleGroupMenu) {
      try {
        const reservationItem: MenuReservationItem = await this.$store.dispatch(CANCEL_EXISTING_RESERVATION, _.first(this.reservationItem)!)
        window.removeEventListener('keyup',this.performSave)
        if(this.timeOut) {
          clearTimeout(this.timeOut)
        }

        this.$emit('reservationChanged', reservationItem, 'canceled')
      } catch (e) {
        this.showSaveErrorMessage(e as AxiosError)
      } finally {
        this.cancellationInProgress = false
      }
    }
  }
  // </editor-fold>

  /**
    * Zmení flag isDataChanged podľa nastavenia rezervácie
    *
    * Vue nepodporuje reaktivitu pre property typu Map a Set. Preto musí byť zmena flagu riešená explicitne.
  */
  updateIsDataChangedFlag (): void {
    this.isAmountChanged = false
    if (!this.reservationItem) {
      this.isDataChanged = false
    } else {
      this.isDataChanged = isSelectionDifferentThenReservation(this.reservationItem, this.currentSelection, this.isMultipleGroupMenu)
    }
  }

  async fetchLatestOrderDetail(): Promise<void> {
    this.lastReservationDetailData = []
    try {
      const promises: Promise<any>[] = []
      this.lastReservationNumber!.forEach((number: number) => {
        let payload: any = number
        promises.push(this.piniaStore.fetchLastOrder(payload))
      })
      const responses = await Promise.all(promises)
      this.lastReservationDetailData.push(responses)
    } catch (e) {
    }
  }

  async fetchLastData(): Promise<void> {
    this.lastReservationNumber = []
    this.isRefreshData = true
    const dashboard = await this.$store.dispatch(FETCH_DASHBOARD)
    dashboard.offerReservationsToRate.forEach((item:any) => {
      this.selectedOfferRating = item.offerReservationRating
      this.lastReservationNumber!.push(item.offerReservation.id)
    })
    this.isRefreshData = false
    if(this.lastReservationNumber !== null) {
      this.fetchLatestOrderDetail()
    }



  }

  showSaveErrorMessage (e: AxiosError): void {
    showErrorResponseDialog(this.$t('orderPage.orderNotSaved'), e, 'V prípade potreby kontaktuje správcu objednávkového systému.')
  }

  destroyed(){
    window.removeEventListener('keyup',this.performSave)
    if(this.timeOut) {
      clearTimeout(this.timeOut)
    }
  }

  setCurrentSelectionByReservation (): void {

    if(this.reservationItem && this.isMultipleGroupMenu){
      let reservedIdList: number[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        item.reservedOfferCollection.forEach((i: any) => {
          reservedIdList.push(i.menuGroupSlot.id)
        })
      })
      this.menuGroupList.forEach((item: MenuGroupItem) => {
        item.subGroupList.forEach((i: MenuGroupItem) => {
          i.optionList.forEach((a: DailyMenuOption) => {
            if(reservedIdList.includes(parseInt(a.id))) {
              if(this.currentSelection.has(i)) {
                this.reservationItem!.forEach((x:any) => {
                  if(a.offer){
                    const foundItem =  x.reservedOffers.find((y:any) => y.dailyMenuOffer.id === a.offer!.id)
                    if(foundItem) {
                      a.offer.amount = foundItem.amount
                    }
                  }
                })

                this.currentSelection.get(i)!.push(a)
              } else {
                this.reservationItem!.forEach((x:any) => {
                  if(a.offer){
                    const foundItem =  x.reservedOffers.find((y:any) => y.dailyMenuOffer.id === a.offer!.id)
                    if(foundItem) {
                      a.offer.amount = foundItem.amount
                    }
                  }
                })

                this.currentSelection.set(i, [a])
              }
            }
          })
        })
      })
    }
  }

  created() {
    const vh = window.innerHeight
    this.cardHeight = `max-height: calc(${vh}px - 240px);height: calc(${vh}px - 240px)`
    this.isMultipleGroupMenu = this.customerConfiguration
    this.setCurrentSelectionByReservation()

  }

  async mounted() {
    await this.fetchData()
    this.setTimeBlock()
    this.business = this.currentUser.tenant.businessCollection[0].id

    if(this.reservationItem && _.first(this.reservationItem)?.topMenuGroup) {
      this.getTabNumber()
    } else if(this.selectedMenu) {
      this.getTabNumber()
    } else{
      this.tab = 0
    }
    this.fetchLastData()
    this.fetchLatestOrderDetail()
  }
}
